// Selection, bulk actions and albums on the Media page.
export const mediaBulk = {
  selected_one: "{{count}} selected",
  selected_few: "{{count}} selected",
  selected_other: "{{count}} selected",
  clearSelection: "Clear selection",
  actions: {
    addCountries: "Add country",
    removeCountries: "Remove country",
    setSource: "Set source",
    star: "Star",
    unstar: "Unstar",
    album: "Add to album",
    move: "Move to type",
    trash: "Move to trash",
    restore: "Restore",
  },
  actionTitles: {
    addCountries: "Add one or more countries to the selected photos",
    removeCountries: "Remove one or more countries from the selected photos",
    setSource: "Set the same source on all selected photos",
    star: "Mark the selected photos as good photos (★)",
    unstar: "Remove the good photo mark (★) from the selected photos",
    album: "Add the selected photos to an album",
    move: "Move the selected photos to another type",
    trash: "Move the selected photos to the trash",
    restore: "Restore the selected photos from the trash",
  },
  countries: {
    addTitle_one: "Add a country to {{count}} photo",
    addTitle_few: "Add a country to {{count}} photos",
    addTitle_other: "Add a country to {{count}} photos",
    removeTitle_one: "Remove a country from {{count}} photo",
    removeTitle_few: "Remove a country from {{count}} photos",
    removeTitle_other: "Remove a country from {{count}} photos",
    label: "Countries",
    save: "Save",
  },
  source: {
    title_one: "Source of {{count}} photo",
    title_few: "Source of {{count}} photos",
    title_other: "Source of {{count}} photos",
    label: "Source",
    hint: "An empty field removes the source from the selected photos.",
    save: "Save",
  },
  confirmDelete: {
    title_one: "Move {{count}} photo to the trash?",
    title_few: "Move {{count}} photos to the trash?",
    title_other: "Move {{count}} photos to the trash?",
    used_one: "{{count}} of {{total}} selected photos is used on the website.",
    used_few: "{{count}} of {{total}} selected photos are used on the website.",
    used_other: "{{count}} of {{total}} selected photos are used on the website.",
    noneUsed: "None of the selected photos is used on the website.",
    confirm: "Move to trash",
  },
  restore: {
    twinsSkipped_one:
      "{{count}} photo skipped: a live photo with the same content is already in the library.",
    twinsSkipped_few:
      "{{count}} photos skipped: live photos with the same content are already in the library.",
    twinsSkipped_other:
      "{{count}} photos skipped: live photos with the same content are already in the library.",
    failed_one: "{{count}} photo could not be restored and stays selected.",
    failed_few: "{{count}} photos could not be restored and stay selected.",
    failed_other: "{{count}} photos could not be restored and stay selected.",
  },
  album: {
    createTitle: "New album",
    createChildTitle: "New sub-album in {{parent}}",
    renameTitle: "Rename album",
    nameLabel: "Album name",
    nameRequired: "Enter the album name.",
    save: "Save",
  },
};
